import React, { useContext } from 'react'
import styles from './ModalThirdView.module.scss'
import { InvoiceModalValues } from './ModalFirstView'
import ModalButton from 'spa/member/components/ModalButton'
import ChangeModal from './changeModal'
import MemberTechCompanyName from "../../../../spa/member/components/MemberTechCompanyName";
import { useWindowWidth } from "../../../../spa/hooks/useWindowWidth";
import { breakpoints } from "../../../../spa/config/styled";

interface ThirdModalProps extends ChangeModal {
  name: string
  companyNameFlag: boolean
}

const ModalThirdView: React.FC<ThirdModalProps> = (props) => {
  const context = useContext(InvoiceModalValues)

  const windowWidth = useWindowWidth()
  const isSp = windowWidth < breakpoints.sm

  const onClickBack = () => {
    context.setErrors([])
    props.changeModal('secondModal')
  }

  const displayNameType = props.companyNameFlag ? '法人名' : '氏名'

  return (
    <div className={styles.overlay}>
      <div className={`${styles.modalContainer} js-modal-container`}>
        <div className={styles.sectionTitle}><p>内容をご確認ください。</p></div>
        <div className={styles.sectionDivider}></div>
        <div className={styles.sectionContents}>
          <div className={styles.label}>適格請求書発行事業者 氏名又は名称（<MemberTechCompanyName />に登録されている{displayNameType}を表示しています）</div>
          <div className={styles.value}>{props.name}</div>
          <div className={styles.label}>インボイス登録番号</div>
          <div className={styles.value}>T{context.invoiceNumber}</div>
        </div>
        <div className={styles.sectionText}>国税庁へ届け出ている内容と{isSp ? <br /> : ''}同一であるか照合を行い、<br/>確認が取れた場合のみ{isSp ? <br /> : ''}入力を完了します。</div>
        <div className={styles.sectionBtn}>
          <ModalButton buttonType='BACK' onClick={() => onClickBack()}>1つ前に戻る</ModalButton>
          <ModalButton buttonType='NEXT' onClick={() => props.changeModal('fourthModal')} className='third-modal-go-next-btn'>照合し入力を完了する</ModalButton>
        </div>
      </div>
    </div>
  )
}
export { ModalThirdView }
